import { Tooltip } from '@payaca/ambrosia';
import { clstx } from '@payaca/utilities/cvaMerge';
import { FC } from 'react';
import { AddressShape } from '../address/types';

export interface IProps {
  className?: string;
  address: AddressShape;
}

// Country is intentionally omitted from the visible line to keep this
// rendering on a single, truncating line where space is tight. The full
// address (including country) is exposed via the tooltip so the user can
// recover it on hover when truncation hides part of the line.
const Address1Line: FC<IProps> = ({ className, address }) => {
  const startParts = [address.line1, address.line2, address.city].filter(
    Boolean
  );
  const start = startParts.join(', ');
  const hasPostcode = !!address.postalCode;

  const fullAddress = [
    address.line1,
    address.line2,
    address.city,
    address.postalCode,
    address.country,
  ]
    .filter(Boolean)
    .join(', ');

  return (
    <Tooltip
      tooltipContent={fullAddress}
      placement="bottom-start"
      className={clstx('block min-w-0', className)}
    >
      <div className="flex min-w-0">
        <span className="truncate">
          {start}
          {start && hasPostcode ? ',' : ''}
        </span>
        {hasPostcode && (
          <span className="shrink-0">&nbsp;{address.postalCode}</span>
        )}
      </div>
    </Tooltip>
  );
};

export default Address1Line;
